<template>
    <nav class="info-menu" :class="active ? 'active' : ''" @mouseleave="onBlur">
        <div class="container">
            <a
                v-for="(item, index) in menuItems"
                :key="index"
                @click="onClick(item)"
                @focus="onFocus($event, item)"
                @mouseover="onFocus($event, item)"
            >
                {{ translate(`giftcard.details.${item}`) }}
            </a>
            <div ref="pointer" class="pointer" :style="pointerStyle">&nbsp;</div>
        </div>
    </nav>
</template>

<script>
import TranslationMixin from '~/mixins/TranslationMixin';
export default {
    name: 'Infomenu',
    mixins: [TranslationMixin],
    props: {
        menuItems: {
            type: Array,
        },
    },
    data() {
        return {
            pointer: {
                left: 0,
                width: 0,
            },
            activeItem: null,
        };
    },
    computed: {
        active() {
            return this.activeItem != null;
        },

        pointerStyle() {
            return {
                left: this.pointer.left + 'px',
                width: this.pointer.width + 'px',
            };
        },
    },
    methods: {
        onFocus(ev, item) {
            this.activeItem = item;
            this.pointer.left = ev.target.offsetLeft;
            this.pointer.width = ev.target.offsetWidth;
        },
        onClick(item) {
            this.$emit('jumpto', item);
        },
        onBlur() {
            this.activeItem = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.info-menu {
    height: 4rem;
    background-color: $color-subheader;
    border-top: 1px solid $color-header-border;
    border-bottom: 1px solid $color-header-border;
    position: relative;

    .pointer {
        position: absolute;
        bottom: -1px;
        left: 0;
        height: 3px;
        background-color: $color-header-underline;
        opacity: 0;
        transition: left 0.2s ease, opacity 0.2s ease, width 0.2s ease;
    }

    &.active .pointer {
        opacity: 1;
        transition: left 0.2s ease, opacity 0.2s ease, width 0.2s ease;
    }

    .container a {
        display: inline-block;
        padding: 1rem 0;
        font-weight: bold;
        line-height: 2rem;
        color: $color-header-link;
        cursor: pointer;

        &:hover {
            text-decoration: none;
            color: $color-header-link-hover;
        }

        &:focus {
            outline: none;
        }

        & + a {
            margin-left: 2rem;
        }
    }

    &::after {
        display: block;
        content: ' ';
        clear: both;
    }

    overflow: visible;

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>
<i18n src="@dundle/locale/data/keywords.json"></i18n>
<i18n src="@dundle/locale/data/giftcard.json"></i18n>
